/* eslint-disable */
export default {
  title: '历史记录',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
